import { render, staticRenderFns } from "./FaqEng.vue?vue&type=template&id=08ac1b08&scoped=true&"
import script from "./FaqEng.vue?vue&type=script&lang=js&"
export * from "./FaqEng.vue?vue&type=script&lang=js&"
import style0 from "./FaqEng.vue?vue&type=style&index=0&id=08ac1b08&prod&lang=scss&"
import style1 from "./FaqEng.vue?vue&type=style&index=1&id=08ac1b08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ac1b08",
  null
  
)

export default component.exports